import styles from './Layout.module.css'

export function ProductNavigation({ items = [], label = 'Product navigation', groupLabel, renderLink, collapsed = false, className = '' }) {
  const visibleItems = items.filter((item) => !item.hidden)
  return (
    <nav
      className={`${styles.productNav} ${collapsed ? styles.productNavCollapsed : ''} ${className}`.trim()}
      aria-label={label}
      data-collapsed={collapsed}
    >
      {groupLabel && visibleItems.length ? <p className={`${styles.productNavLabel} ${collapsed ? 'wf-visually-hidden' : ''}`.trim()}>{groupLabel}</p> : null}
      <ul className={styles.productNavList}>
        {visibleItems.map((item) => {
          const accessibleLabel = item.accessibleLabel || item.label
          const content = (
            <>
              {item.icon}
              <span className={styles.productNavText} aria-hidden={collapsed || undefined}>{item.label}</span>
              {item.count != null ? <span className={styles.productNavCount} aria-hidden={collapsed || undefined}>{item.count}</span> : null}
            </>
          )
          const linkProps = {
            className: `${styles.productNavLink} ${item.active ? styles.productNavLinkActive : ''}`.trim(),
            'aria-current': item.active ? 'page' : undefined,
            'aria-label': collapsed ? accessibleLabel : undefined,
            title: collapsed ? accessibleLabel : undefined,
          }
          return <li key={item.key || item.href}>{renderLink?.(item, content, linkProps) || <a {...linkProps} href={item.href}>{content}</a>}</li>
        })}
      </ul>
    </nav>
  )
}
